var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPindevelopement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.926,
    height: 38.568,
    viewBox: "0 0 28.926 38.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4905b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a23"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin_Icon",
    "data-name": "Pin Icon",
    transform: "translate(-719.074 -422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-bookmark",
    "data-name": "Icon ionic-md-bookmark",
    d: "M32.784,4.5H11.893A4.029,4.029,0,0,0,7.875,8.518V43.068L22.338,36.64,36.8,43.068V8.518A4.029,4.029,0,0,0,32.784,4.5Z",
    transform: "translate(711.199 417.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pin",
    d: "M-466.255,5064.279a.945.945,0,0,1-.667-1.157l1.22-4.556-5.468-1.465.43-1.6a1.888,1.888,0,0,1,1.449-1.36l1.842-.386a1.883,1.883,0,0,0,1.449-1.359l1.163-4.338-.911-.245a1.887,1.887,0,0,1-1.335-2.311,1.887,1.887,0,0,1,2.311-1.335l7.29,1.954a1.888,1.888,0,0,1,1.335,2.312,1.886,1.886,0,0,1-2.311,1.333l-.911-.244-1.163,4.338a1.891,1.891,0,0,0,.574,1.9l1.4,1.254a1.889,1.889,0,0,1,.574,1.9l-.431,1.6-5.468-1.465-1.22,4.556a.944.944,0,0,1-.911.7A.962.962,0,0,1-466.255,5064.279Z",
    transform: "translate(1197.164 -4612.922)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPindevelopement);
export default __webpack_public_path__ + "static/media/pindevelopement.3ae4dea8f6f98264ba7c156806391e58.svg";
export { ForwardRef as ReactComponent };